<template>
  <div class="form-body">
    <div class="row">
      <div class="form-holder">
        <div class="form-content" style="padding: 0px;">
          <div class="form-items">
            <!-- <span class="logo" v-html="logos"></span> -->
            <div class="row mt-5"></div>
            <!-- <h3>Welcome to Screenit</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
            <div class="container">
              <b-form
                class="register-form"
                style="background-color: #ffffff;padding: 20px;"
                method="post"
              >
                <div>
                  <div class="form-row">
                    <h1
                      class="float-left mb-0 ml-3"
                      style="all:unset; font-size:25px"
                    >
                      HI {{ form.firstName }}
                    </h1>
                  </div>
                  <br />
                  <div class="form-row">
                    <h3 class="float-left mb-0 ml-3">Interviewer Experience</h3>
                  </div>
                  <hr />
                  <div class="form-row">
                    <div class="form-group designation">
                      <b-form-input
                        type="text"
                        placeholder="Designation*"
                        v-model="form.designation"
                        :class="{
                          'is-invalid': submitted && $v.form.designation.$error
                        }"
                      />
                      <div v-if="submitted && $v.form.designation.$error">
                        <p
                          v-if="!$v.form.designation.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter the Desingantion
                        </p>
                      </div>
                    </div>
                    <br>
                    <div class="form-row experience">
                      <div>
                        <label style="text-align:center" for=""
                          >Total Years of Experience</label
                        >
                        <div class="form-group selectyear">
                          <div class="form-select">
                            <select
                              v-model="form.Experience"
                              class="form-control"
                              @change="getTime($event)"
                              :class="{
                                'is-invalid':
                                  submitted && $v.form.Experience.$error
                              }"
                            >
                              <option value="" class="text" disabled
                                >Years*</option
                              >
                              <option v-for="get in 30" :key="get"
                                >{{ get }} years</option
                              >
                            </select>
                            <span class="select-icon"
                              ><i class="fa fa-chevron-down"></i
                            ></span>
                          </div>
                          <div v-if=" $v.form.Experience.$error">
                            <p
                              v-if="!$v.form.Experience.required"
                              class="login-alert-msg error-content"
                            >
                              * Select year
                            </p>
                          </div>
                        </div>
                        <div class="form-group selectmonth">
                          <div class="form-select">
                            <select
                              v-model="form.month_of_experience"
                              class="form-control selyear"
                              :class="{
                                'is-invalid':
                                  submitted &&
                                  $v.form.month_of_experience.$error
                              }"
                            >
                              <option value="" class="text" disabled
                                >Months*</option
                              >
                              <option v-for="get in 12" :key="get"
                                >{{ get }} months</option
                              >
                            </select>
                            <span class="select-icon"
                              ><i class="fa fa-chevron-down"></i
                            ></span>
                          </div>
                          <div
                            v-if="
                              submitted && $v.form.month_of_experience.$error
                            "
                          >
                            <p
                              v-if="!$v.form.month_of_experience.required"
                              class="login-alert-msg error-content"
                            >
                              * Select month
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <div class="form-select">
                        <select
                          v-model="form.organizationStatus"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.organizationStatus.$error
                          }"
                        >
                          <option value="" class="text" disabled
                            >Current Status*</option
                          >
                          <option> Employed </option>
                          <option>Unemployed</option>
                          <option>Self Employed</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div
                        v-if="submitted && $v.form.organizationStatus.$error"
                      >
                        <p
                          v-if="!$v.form.organizationStatus.required"
                          class="login-alert-msg error-content"
                        >
                          * Select your Current Status
                        </p>
                      </div>
                    </div>
                    <div class="form-group  org">
                      <b-form-input
                        type="text"
                        placeholder="Current Organization*"
                        v-model="form.current_user_organization"
                        :class="{
                          'is-invalid':
                            submitted &&
                            $v.form.current_user_organization.$error
                        }"
                      />
                      <div
                        v-if="
                          submitted && $v.form.current_user_organization.$error
                        "
                      >
                        <p
                          v-if="!$v.form.current_user_organization.required"
                          class="login-alert-msg error-content"
                        >
                          * Enter Current Status
                        </p>
                        <!-- <p v-if="!$v.form.current_user_organization.alpha" class="login-alert-msg error-content">* Only allows alphabetic characters</p> -->
                      </div>
                      <!-- <br /> -->
                      <!-- <div class="term">
                        <input type="checkbox" style="width:10%" /><label
                          class="currentemp"
                          >Hide current employer</label
                        >
                      </div> -->
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <div class="form-select">
                        <select
                          v-model="form.currency_name"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.currency_name.$error
                          }"
                        >
                          <option value="" class="text" disabled
                            >Interview Cost*</option
                          >
                          <option> INR </option>
                          <option>USD</option>
                        </select>
                        <span class="select-icon"
                          ><i class="fa fa-chevron-down"></i
                        ></span>
                      </div>
                      <div v-if="submitted && $v.form.currency_name.$error">
                        <p
                          v-if="!$v.form.currency_name.required"
                          class="login-alert-msg error-content"
                        >
                          * Select your value
                        </p>
                      </div>
                    </div>
                    <div class="form-group interview_cost">
                      <b-form-input
                        type="text"
                        placeholder="Add Interview Cost*"
                        v-model="form.interview_cost"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.interview_cost.$error
                        }"
                      />
                      <div v-if="submitted && $v.form.interview_cost.$error">
                        <p
                          v-if="!$v.form.interview_cost.required"
                          class="login-alert-msg error-content"
                        >
                          * Add the Interview Cost
                        </p>
                        <!-- <p v-if="!$v.form.interview_cost.number" class="login-alert-msg error-content">* Only allows alphabetic characters</p> -->
                      </div>
                      <div>
                        <!-- <a href="">Guidelines</a> -->
                        <br />
                        <!-- Button trigger modal -->
                        <button
                          type="button"
                          style="background:none; all:unset; color:green"
                          class="btn"
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          Guidelines
                        </button>

                        <!-- Modal -->
                        <div
                          class="modal fade"
                          id="exampleModal"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h4
                                  class="modal-title guideline"
                                  id="exampleModalLabel"
                                  style="padding:4px"
                                >
                                  Guideline to determine the interview cost
                                  <button
                                  type="button"
                                  class="close icon"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                </h4>
                              </div>
                              <div class="modal-body">
                                <p style="font-size:14px">
                                  o  Arrive the cost based on the skills that you interview, below are the Band rate as per the standards
                          <ul class="rateforInterview"><li>0 - 5 Years - 300 INR</li>
                          <li>6 -  8 Years -500 INR</li>
                          <li>8 - 12 Years - 750 INR</li>
                          <li>Above 12 Years - 1000 INR</li></ul>
                                  o  Cost / Interview is highly acceptable by the organization when you have a good track record of taking interviews on time and reviews.
                                  <br />
                                  o   In case if you are not getting an interview request from the Organisation, your cost might be the cause. So kindly rethink.
                                  <br />
                                  o  The recommended cost per interview is the cost per hour of your skill.
                                </p>
                              </div>
                              <div class="modal-footer">
                                <div class="footercontent"><p style="color:black"> <strong> Note : Payment will be processed within 10-12 working days </strong></p>
                                <button
                                  type="button"
                                  class="btn btn-success"
                                  data-dismiss="modal"
                                >
                                  Close
                                </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-col">
                    <div class="form-group signupbtn">
                      <button
                        to="/InterviewerSkills"
                        type="button"
                        class="btn btn-success btn-md pull-right"
                        v-on:click.prevent="onSubmitProfile"
                      >
                        Sign Up
                      </button>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
export default {
  name: 'userprofile',
  components: {},
  data () {
    return {
      form: {
        designation: '',
        Experience: '',
        month_of_experience: '',
        organizationStatus: '',
        current_user_organization: '',
        currency_name: '',
        interview_cost: '',
        firstName: localStorage.getItem('firstName')
      },
      updateExp: '',
      user_id: '',
      submitted: false
    }
  },
  computed: {},
  created () {
    localStorage.getItem('firstName')
    localStorage.getItem('_id')
    this.submitted = true
    // return this.$v.$touch()
  },
  mixins: [validationMixin],
  validations: {
    form: {
      designation: {
        required

      },
      Experience: {
        required
      },
      month_of_experience: {
        required
      },
      organizationStatus: {
        required,
        maxLength: maxLength(20)
      },
      current_user_organization: {
        required
      },
      currency_name: {
        required
      },
      interview_cost: {
        required
      }
    }
  },
  methods: {
    getTime (event) {
      this.form.Experience = this.yearList.find(
        item => item.id === Number(event.target.value)
      )
    },
    onSubmitProfile () {
      this.submitted = true
      this.user_id = localStorage.getItem('_id')
      if (this.submitted && this.$v.form.$invalid) {
        this.$v.$touch()
      } else {
        const data = {
          designation: this.form.designation,
          Experience: this.form.Experience,
          current_user_organization: this.form.current_user_organization,
          month_of_experience: this.form.month_of_experience,
          organizationStatus: this.form.organizationStatus,
          currency_name: this.form.currency_name,
          interview_cost: this.form.interview_cost
        }
        axios
          .post(BaseURL + '/profile/update_user_profile_ios/' + this.user_id, {
            formData: data
          })
          .then(response => {
            this.updateExp = response.data.userInfo
            this.signup = response.data.message
            localStorage.setItem('user__details', JSON.stringify(this.updateExp))
            console.log(this.signup)
            if (this.signup === 'Success') {
              this.$awn.success('Experience is updated Successfully')

              this.$router.push('/InterviewerSkills')
            } else {
              alert('Email already exist')
            }
          })
      }
    }
  }
}
</script>
<style scoped>
.footercontent{
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.guideline{
  display: flex;
  justify-content: space-between;
  color:black;
}
.rateforInterview{
  display: flex;
  flex-direction: column;
  text-align: center;
  /* justify-content: center; */
  /* text-align: center; */
  color:black;
  font-size:16px;
  list-style: none;
  font-weight: 700;
}
.icon {
  display: inline-block;
  padding: 5px;
}
.interview_cost {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: flex-end;
}
.org {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.currentemp {
  width: 100%;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.term {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
}
.designation {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-end;
}
.selectyear,
.selectmonth {
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-evenly;
}
.experience {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.terms {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.signupbtn {
  display: flex;
  justify-content: center;
}

.form-content .form-items {
  border: none !important;
  box-shadow: none !important;
}

/* .form-content .form-items {
    background-color: #ffffff !important;
} */
.newDesign {
  width: 44%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto !important;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5bad2b;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.input-group.form-control.is-valid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}
.input-group.form-control.is-invalid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}

input.form-control.is-valid {
  background-image: none !important;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}

.form-content .form-items {
  max-width: 70%;
  padding: 25px;
  border: 1px solid #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);
}

svg {
  width: 100%;
}

.content-title {
  padding: 35px 0px 35px 105px;
}

.content-title-header {
  font-size: 22px;
  color: #000000;
}

.content-title-sub-header {
  color: #2f2f2f;
  font-size: 15px;
}

display-flex,
.signup-content,
.form-row,
.form-radio,
.select-icon,
.select-icon i {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.file-loading {
  width: 50%;
}

img {
  max-width: 254px;
  height: auto;
}

figure {
  margin: 0;
}

.clear {
  clear: both;
}

.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  background: #f5f5f5;
}

.signup-img {
  width: 30%;
}

.signup-form {
  width: 70%;
}

.form-row {
  margin: 0 -15px;
}

.form-row .form-group {
  width: 50%;
  padding: 0 15px;
}

.form-group {
  margin-bottom: 15px !important;
  position: relative;
}
.form-items {
  margin-top: 2%;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
}

.form-radio {
  margin-bottom: 18px;
}

.form-radio input {
  width: auto;
  display: inline-block;
}

.radio-label {
  padding-right: 72px;
}

.form-radio-item {
  position: relative;
  margin-right: 45px;
}

.form-radio-item label {
  font-weight: 400;
  font-size: 13px;
  padding-left: 25px;
  position: relative;
  z-index: 9;
  display: block;
  cursor: pointer;
}

.check {
  display: inline-block;
  position: absolute;
  border: 1px solid #ebebeb;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  height: 13px;
  width: 13px;
  top: 4px;
  left: 0px;
  z-index: 5;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;
}

.check:before {
  position: absolute;
  display: block;
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  top: 2px;
  left: 2px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

input[type="radio"]:checked ~ .check {
  border: 1px solid #4dbd74;
}

input[type="radio"]:checked ~ .check::before {
  background: #4dbd74;
}

.form-select {
  position: relative;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}

.form-submit {
  text-align: right;
  padding-top: 27px;
}

@media screen and (max-width: 1024px) {
  /* .register-form {
    padding: 0px 40px 50px 0px;
  } */

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 125px;
  }

  .image-design {
    height: 254px;
  }

  .container {
    width: 100%;
    max-width: 100% !important;
  }
}

@media screen and (max-width: 992px) {
  .container {
    width: 100%;
    max-width: 100% !important;
  }

  .signup-img {
    width: 30%;
  }

  .signup-form {
    width: 70%;
  }

  .image-width {
    width: 100%;
    height: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }
}

@media screen and (max-width: 800px) {
  .form-content .form-items {
    max-width: 100%;
    padding: 15px;
    border: none;
    box-shadow: none;
  }

  .signup-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }

  .image-design {
    height: 354px;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .signup-img,
  .signup-form {
    width: 100%;
  }

  .form-content .form-items {
    max-width: 100% !important;
    padding: 15px !important;
    border: none !important;
    box-shadow: none !important;
  }
}

@media screen and (max-width: 575px) {
  .form-row {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    margin: 0px;
  }

  .form-row .form-group {
    width: 100%;
    padding: 0px;
  }

  .radio-label {
    padding-right: 22px;
  }

  .form-radio-item {
    margin-right: 25px;
  }
}

@media screen and (max-width: 480px) {
  .form-radio {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }
}

.image-design {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.form-content {
  width: auto;
}
.form-row {
  margin: inherit;
}
.form-content h3 {
  margin-bottom: auto;
  margin-top: auto;
}
.mt-5 {
  margin-top: 35px;
}
.profile-image-center img {
  max-width: 100px;
  height: 100px;
}
.btn {
  width: 30%;
  height: 35px;
}
select.is-invalid {
  border: 1px solid red;
}
.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-left
  .vicp-range
  input[type="range"] {
  /* display: block; */
  padding-top: 10px !important;
}
.grey_color {
  color: #acacac !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 0%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 14px;
  color: black;
  border: 1px solid #ccc;
}
   @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {

.experience {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
   }
</style>
